// This file was automatically generated from appchart.dialog.schedulePLRMassImport.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.schedulePLRMassImport');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.schedulePLRMassImport.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8LargeFontSize" style="text-align: center">Signing and Importing PLR Documents for the current patient. (This may take up to several minutes. Please keep this tab open.)<div class="el8Loading" style="text-align: center;"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.schedulePLRMassImport.done = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8LargeFontSize padt30" style="text-align: center">', soy.$$escapeHtml(opt_data.itemsImported), ' documents have been signed &amp; imported for the current patient.</div><div class="el8LargeFontSize padt30" style="text-align: center"><button class="el8button done-okay-trigger">Refresh Chart</button></div></div>');
  if (!opt_sb) return output.toString();
};
